import { SET_IS_AUTO_REGISTER_SUCCESS } from "./reducers";


export const setIsAutoRegisterSuccess = (payload: boolean) => ({ type: SET_IS_AUTO_REGISTER_SUCCESS, payload });
